<template>
  <div>
    <list
      row-key="CarId"
      ref="list"
      unit="车辆管理"
      @reset="showTree?$refs.treeSelect.clearHandle():null"
      :expand-all-row="true"
      :page="true"
      :query-params="params"
      :show-checkbox="showCheckbox&&($permission.canDel()||$permission.canRecord())"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构" v-if="showTree">
          <tree-select
            ref="treeSelect"
            :props="props"
            :options="TreeData"
            :value="DpId"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="审批状态" v-if="showStatus">
          <el-select v-model="params.Status" clearable>
            <el-option :value="0" label="草稿"/>
            <el-option :value="1" label="待审批"/>
            <el-option :value="2" label="退回"/>
            <el-option :value="3" label="已审批"/>
          </el-select>
        </el-form-item>
        <el-form-item label="备案状态" v-if="showRecord">
          <el-select v-model="params.RecordStatus" clearable>
            <el-option :value="0" label="未备案"/>
            <el-option :value="1" label="备案中"/>
            <el-option :value="2" label="备案失败"/>
            <el-option :value="3" label="备案通过"/>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model="params.CarNo" clearable placeholder="请填写车牌号"></el-input>
        </el-form-item>
        <el-form-item label="车辆品牌">
          <el-input v-model="params.Brand" clearable placeholder="请填写车辆品牌"></el-input>
        </el-form-item>
        <el-form-item label="排挡类别">
          <el-select v-model="params.GearType" clearable>
            <el-option :value="0" label="自动"/>
            <el-option :value="1" label="手动"/>
          </el-select>
        </el-form-item>
        <el-form-item label="培训车型">
          <el-select v-model="params.TrainCarType" clearable>
            <el-option v-for="item in trainList" :key="item.DataId" :value="item.DataName"/>
          </el-select>
        </el-form-item>
        <el-form-item label="资产类型">
          <el-select v-model="params.AssetsType" clearable>
            <el-option :value="0" label="自营"/>
            <el-option :value="1" label="加盟"/>
          </el-select>
        </el-form-item>
        <el-form-item label="生产厂家">
          <el-input v-model="params.Manufactor" clearable placeholder="请填写生产厂家"></el-input>
        </el-form-item>
        <el-form-item label="车辆排量">
          <el-input v-model="params.StartVolume" clearable style="width:120px;" type="numer" placeholder="请填写数值"></el-input>
          -
          <el-input v-model="params.EndVolume" clearable style="width:120px;" type="number" placeholder="请填写数值"></el-input>
        </el-form-item>
        <el-form-item label="报废日期">
          <el-date-picker
            v-model.trim="params.ScrapStartDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.ScrapEndDate"
            clearable
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="年审日期">
          <el-date-picker
            v-model.trim="params.ReviewStartDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            v-model.trim="params.ReviewEndDate"
            clearable
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
        </el-form-item>
        <el-checkbox v-model="params.Scrap">显示报废车辆</el-checkbox>
      </template>
      <template slot="table">
        <el-table-column prop="CarNo" label="车牌号">
          <template slot-scope="{row}">
            <span :style="$permission.canRecord()&&(row.RecordStatus==0||row.RecordStatus==2)?'color:#f11;':''">{{row.CarNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Color" label="车辆颜色" />
        <el-table-column prop="TrainCarType" label="培训车型" />
        <el-table-column prop="BuyAge" label="车龄" />
        <el-table-column prop="Brand" label="车辆品牌" />
        <el-table-column prop="AssetsType" label="资产类型">
          <template slot-scope="{row}">
            <span v-if="row.AssetsType==0">自营</span>
            <span v-else-if="row.AssetsType==1">加盟</span>
          </template>
        </el-table-column>
        <el-table-column prop="Lv" label="技术等级" />
        <el-table-column prop="RegisterDate" label="注册日期" min-width="100">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.RegisterDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="ReviewDate" label="年审日期" min-width="100">
          <template slot-scope="{row}">
            <span :style="isPass(row.ReviewDate)?'color:#f11;':''">{{$commonJs.toDateString(row.ReviewDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ScrapDate" label="报废日期" min-width="100">
          <template slot-scope="{row}">
            <span :style="isPass(row.ScrapDate)?'color:#f11;':''">{{$commonJs.toDateString(row.ScrapDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DpName" label="归属机构" min-width="140"/>
        <el-table-column prop="Status" label="审批状态" width="90" align="center" v-if="showStatus">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">草稿</el-tag>
            <el-tag type="warning" v-else-if="row.Status==1">待审批</el-tag>
            <el-tag type="danger" v-else-if="row.Status==2">退回</el-tag>
            <el-tag type="success" v-else-if="row.Status==3">已审批</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="RecordStatus" label="备案状态" width="90" align="center">
          <template slot-scope="{row}">
            <span v-if="row.RecordStatus==0" style="color:#f11;">未备案</span>
            <span v-else-if="row.RecordStatus==1">备案中</span>
            <span v-else-if="row.RecordStatus==2" style="color:#f11;">备案失败</span>
            <span v-else-if="row.RecordStatus==3">备案通过</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>

import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: {
    list,
    treeSelect
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showTree: {
      type: Boolean,
      default: true
    },
    showRecord: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      api: require("@/api/schoolmanage/car").default,
      basicApi: require("@/api/basic/data").default,
      dpApi: require("@/api/basic/dp").default,
      params: {
        DpIdChain: "",
        CarNo: "",
        Brand: "",
        GearType: null,
        TrainCarType: "",
        AssetsType: null,
        Manufactor: "",
        StartVolume: null,
        EndVolume: null,
        ScrapStartDate: "",
        ScrapEndDate: "",
        ReviewStartDate: "",
        ReviewEndDate: "",
        Scrap: false,
        Status: null,
        RecordStatus: null,
      },
      TreeData: [],
      trainList: [],
      DpId: null,
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    this.basicApi.list({ ClassName:"培训车型", Status:1 }).then(res => {
      this.trainList = res.Data
    });
    this.dpApi.getAuthList({ DpTypes: [2,3,4,5], Status: 3, NoReturnParent: true }).then((res) => {
      this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
    });
  },
  methods: {
    onTreeSelect(t) {
      if (!t) {
        this.params.DpIdChain = "";
        this.DpId = null;
      } else {
        this.params.DpIdChain = t.IdChain;
        this.DpId = t.DpId;
      }
    },
    isPass(time) {
      return (new Date(time)).getTime() < new Date().getTime() - 86400000;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>